import { render } from "./BioForm.vue?vue&type=template&id=07a10f2e"
import script from "./BioForm.vue?vue&type=script&lang=js"
export * from "./BioForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__